import { Link } from "react-router-dom";

const Page404 = () => {
  return (
    <div className="flex items-center justify-center w-full h-screen">
      <div className="text-center">
        <h1 className="text-6xl font-bold text-text-main mb-4">404</h1>
        <h2 className="text-2xl font-semibold text-text-main mb-2">Oops! Page not found</h2>
        <p className="text-text-muted mb-6">We can't find the page you're looking for.</p>
        <Link
          to="/"
          className="inline-flex items-center justify-center rounded-full bg-gradient-to-r from-gradient-start to-gradient-end px-6 py-3 font-sans text-lg font-semibold text-white shadow-md transition hover:opacity-80"
        >
          Return to Home
        </Link>
      </div>
    </div>
  );
};

export default Page404;
